import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { HECoSSubjectValidatorService } from '@uc/web/core';

export const hecosSubjectsResolver: ResolveFn<boolean> = async () => {
	const hecosSubjectsValidatorSrv = inject(HECoSSubjectValidatorService);

	const hecosSubjects = hecosSubjectsValidatorSrv.fetchHECoSSubjects();

	return !!hecosSubjects;
};
